import Mandatory from './Mandatory'

export default Mandatory
